import { createFileRoute } from "@tanstack/react-router";
import { ServerErrorPage } from "@/components/errors/ServerErrorPage";

export const Route = createFileRoute("/500")({
  head: () => ({
    meta: [
      { title: "Something went wrong · Currency Thoughts" },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: () => <ServerErrorPage />,
});